import { render, staticRenderFns } from "./FeatureBubbleButton.vue?vue&type=template&id=4a31baee&scoped=true&"
import script from "./FeatureBubbleButton.vue?vue&type=script&lang=js&"
export * from "./FeatureBubbleButton.vue?vue&type=script&lang=js&"
import style0 from "./FeatureBubbleButton.vue?vue&type=style&index=0&id=4a31baee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a31baee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
